import GridTemplate from '../../html/components/grid.html'
import GridItemTemplate from '../../html/components/grid-item.html'

import Component from '../shared/component'

export const Grid = Component('v-grid', {
  template: GridTemplate,
  props: {
    orientation: {
      type: String,
      default: 'horizontal',
      validator (value) {
        return value === 'horizontal' || value === 'vertical'
      }
    },
    narrow: {
      type: Boolean,
      default: false
    },
    padded: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    classes () {
      return {
        'is-narrow': this.narrow,
        'is-padded': this.padded,
        [`is-${this.orientation}`]: true
      }
    }
  }
})

export const GridItem = Component('v-grid-item', {
  template: GridItemTemplate,
  props: {
    size: {
      type: [
        String,
        Number
      ],
      default: null
    },
    grow: {
      type: [
        String,
        Number
      ],
      default: 0
    },
    shrink: {
      type: [
        String,
        Number
      ],
      default: 0
    }
  },
  computed: {
    basis () {
      let {size} = this
      let unit = 'px'

      if (size === null) {
        return 'auto'
      }

      switch (size.constructor) {
        case String:
          size = parseFloat(size)
          break
        case Number:
      }

      if (size <= 1) {
        size *= 100
        unit = '%'
      }

      return `${size}${unit}`
    },

    style () {
      return this.size && {
        flex: `${this.grow} ${this.shrink} ${this.basis}`
      }
    }
  }
})
